import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import Theme from './theme';


export default function index({ children }) {
    return <ThemeProvider theme={Theme}>{children}</ThemeProvider>
}
